import React from 'react';
import HowWorksPanel from './HowWorksPanel';
import teslaFront from '../../../images/teslaFront.png';
import content from './HowWorksContent';

const HowWorksLeft = ({ isVisible }) => (
  <div className="section-1__how-works--left">
    <div className="section-1__how-works__image-container">
      <img
        className="section-1__how-works__image"
        src={teslaFront}
        alt=""
      />
    </div>
    <HowWorksPanel element={content} />
  </div>
);

export default HowWorksLeft;



// WEBPACK FOOTER //
// ./src/components/Static/LandingPageNYC/HowWorksLeft.js